const ITEMS = [
  "GIN AND MARMALADE",
  "ROSSO",
  "JAZZ CLUB",
  "FOREST ESSENCE",
  "MADE IN CANADA",
  "HYDRATE REFRESH ATTRACT",
];

export const Marquee = () => {
  const row = (key) => (
    <span key={key} className="flex items-center gap-10">
      {ITEMS.map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center gap-10">
          <span>{item}</span>
          <span className="opacity-40">&bull;</span>
        </span>
      ))}
    </span>
  );

  return (
    <div
      data-testid="scent-marquee"
      className="border-b border-[var(--line)] py-3 overflow-hidden select-none bg-[var(--gold-soft)]"
    >
      <div className="mq label-caps text-[10px] text-[var(--ink)]/70 flex items-center gap-10">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
